import { useMutation, useQueryClient } from '@tanstack/react-query';
import { getSubdomain } from '@zealy/utils';
import { twitterAutomationKeys } from '../twitterAutomation.keys';
import { toggleAutomation } from '../twitterAutomation.service';
export const useToggleAutomation = (subdomain = getSubdomain()) => {
    const queryClient = useQueryClient();
    return useMutation({
        mutationFn: ({ automationId, active }) => toggleAutomation(subdomain, automationId, active),
        onSuccess: () => {
            queryClient.invalidateQueries({ queryKey: twitterAutomationKeys.list(subdomain) });
        },
    });
};
